import React from "react";
import "../styles/components.css";

export default function AboutSection() {
    return (
        <section className="home-about">
            <div className="about-text">
                <h2>About Beach Bum Pass</h2>
                <h3>Set Sail for the Best of Destin & Fort Walton Beach!</h3>
                <p>
                    
                    Beach Bum Pass is your local treasure map to the Emerald Coast. We bundle premier Destin & Fort Walton Beach adventures - like local Dolphin Cruises, Deep Sea Fishing Trips, Crab Island Adventures, and Snorkeling Excursions - into one single prepaid digital pass.
From                family fun in the sun to local favorites only beach bums know about, we help you spend less time planning and more time making memories. Whether you're here for a vacation, a weekend getaway, or a day of coastal mischief, your next adventure is just a tap away.                </p>
                
            </div>
            <div className="about-image">
                <img src="/assets/Graphics/Logo_Transparent.png" alt="" />
            </div>
        </section>
    );
}